<div
  class="cb-input-wrapper"
  [class.cb-disabled]="isDisabled()"
  [class.cb-required]="required()"
  [class.cb-readonly]="isReadonly()"
  [class.cb-click-only]="isClickOnly()"
  [class.cb-error]="error()"
  (click)="!disabled() ? inputClick.emit($event) : null"
>
  @if (label() || info()) {
    <div class="cb-input-label">
      @if (label()) {
        <label>{{ label() }}</label>
      }
      @if (info() && info()!.length > 0) {
        <cb-icon
          [cbTooltip]="info()!"
          tooltipPosition="top"
          tooltipStyle="dark"
          name="cb-base-outline-help"
        ></cb-icon>
      }
    </div>
  }
  <div class="cb-input-container">
    @if (leadingText()) {
      <div class="cb-input-leading-text">
        <p>{{ leadingText() }}</p>
      </div>
    }
    @if (leadingDropdownOptions() && leadingDropdownOptions().length > 0) {
      <div
        tabindex="0"
        class="cb-input-leading-dropdown"
        [cbPopover]="LeadingDropdownOptions"
      >
        <p>{{ selectedLeadingText }}</p>
        <cb-icon name="cb-base-outline-chevron-down"></cb-icon>
      </div>
    }
    @if (leadingTemplate()) {
      <div
        class="cb-input-leading-template"
        [class.cb-clickable]="leadingTemplateClickable()"
        (click)="onLeadingTemplateClick()"
      >
        <ng-container
          *ngTemplateOutlet="
            leadingTemplate()!;
            context: { $implicit: value() }
          "
        ></ng-container>
      </div>
    }
    <div
      class="cb-input"
      [class.cb-reset]="resetButton() && value() && value()!.length > 0"
    >
      @if (icon() || prefix() || leadingIcon()) {
        <div #Prefix class="cb-input-prefix">
          @if (icon()) {
            <cb-icon [name]="icon()!"></cb-icon>
          }
          @if (prefix()) {
            <p>{{ prefix() }}</p>
          }
          @if (leadingIcon()) {
            <ng-container *ngTemplateOutlet="leadingIcon()!"> </ng-container>
          }
        </div>
      }
      <input
        #Input
        [(ngModel)]="value"
        [shownMaskExpression]="shownMaskExpression ?? null"
        [mask]="mask()"
        [type]="currentType"
        [disabled]="isDisabled() || isClickOnly() || isReadonly()"
        [placeholder]="placeholder() ?? ''"
        [attr.autocomplete]="autocomplete()"
        [attr.name]="name()"
        (blur)="onTouchedCallback(); blur.emit()"
        (input)="input.emit(value() ?? '')"
        [attr.maxlength]="maxLength()"
        (keydown.enter)="enter.emit($event)"
      />
      @if (type() == "password" || suffix() || trailingIcon()) {
        <div #Suffix class="cb-input-suffix">
          @if (type() == "password" && showEyeIcon()) {
            <cb-icon
              (click)="passwordShown = !passwordShown"
              class="cb-input-password-icon"
              [name]="
                passwordShown ? 'cb-base-outline-eyeoff' : 'cb-base-outline-eye'
              "
            ></cb-icon>
          }
          @if (suffix()) {
            <p class="cb-input-suffix">{{ suffix() }}</p>
          }
          @if (trailingIcon()) {
            <ng-container *ngTemplateOutlet="trailingIcon()!"> </ng-container>
          }
        </div>
      }
      @if (resetButton() && value() && value()!.length > 0) {
        <div class="cb-input-reset-button-container" (click)="reset()">
          <div class="cb-input-reset-button">
            <cb-icon name="cb-base-outline-close"></cb-icon>
          </div>
        </div>
      }
    </div>
    @if (trailingTemplate()) {
      <div
        class="cb-input-trailing-template"
        [class.cb-clickable]="trailingTemplateClickable()"
        (click)="onTrailingTemplateClick()"
      >
        <ng-container
          *ngTemplateOutlet="
            trailingTemplate()!;
            context: { $implicit: value() }
          "
        ></ng-container>
      </div>
    }
    @if (trailingDropdownOptions() && trailingDropdownOptions().length > 0) {
      <div
        tabindex="0"
        class="cb-input-trailing-dropdown"
        [cbPopover]="TrailingDropdownOptions"
      >
        <p>{{ selectedTrailingText }}</p>
        <cb-icon name="cb-base-outline-chevron-down"></cb-icon>
      </div>
    }
    @if (trailingText()) {
      <div
        [class.cb-clickable]="trailingTemplateClickable()"
        (click)="onTrailingTemplateClick()"
        class="cb-input-trailing-text cb-input-trailing-template"
      >
        <p>{{ trailingText() }}</p>
      </div>
    }
    @if (copyButton()) {
      <div class="cb-input-trailing-action" (click)="copyText()">
        <cb-icon name="cb-base-outline-copy"></cb-icon>
      </div>
    }
  </div>
  @if (hint() && hint()!.length > 0) {
    <p class="cb-input-hint">{{ hint() }}</p>
  }
</div>

<ng-template #LeadingDropdownOptions let-close="close">
  <div class="cb-input-dropdown-options">
    <div class="cb-input-dropdown-search">
      <cb-input
        [(ngModel)]="leadingDropdownSearch"
        (change)="filterLeadingDropdown()"
        icon="cb-base-outline-search"
        [placeholder]="'COMMON.SEARCH' | translate"
      ></cb-input>
    </div>
    @for (item of filteredLeadingDropdownOptions(); track $index) {
      <div
        class="cb-input-dropdown-option"
        (click)="selectLeadingValue(item); close()"
      >
        <p>{{ item.label }}</p>
        @if (leadingDropdownValue()?.value === item.value) {
          <cb-icon name="cb-base-outline-check"></cb-icon>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #TrailingDropdownOptions let-close="close">
  <div class="cb-input-dropdown-options">
    <div class="cb-input-dropdown-search">
      <cb-input
        [(ngModel)]="trailingDropdownSearch"
        (change)="filterTrailingDropdown()"
        icon="cb-base-outline-search"
        [placeholder]="'COMMON.SEARCH' | translate"
      ></cb-input>
    </div>
    @for (item of filteredTrailingDropdownOptions(); track $index) {
      <div
        class="cb-input-dropdown-option"
        (click)="selectTrailingValue(item); close()"
      >
        <p>{{ item.label }}</p>
        @if (trailingDropdownValue()?.value === item.value) {
          <cb-icon name="cb-base-outline-check"></cb-icon>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #DropdownOption let-item let-selected="isSelected"> </ng-template>
